import IUserFormData from '../interfaces/IUserFormData';
import UserType from '../components/user-form-infos/enums/user-type';
import { getAuthAxiosInstance } from '../../../../../common/services/axios-config';
import ISaveUserRequestRequest from '../../../interfaces/ISaveUserRequestRequest';
import ISaveUserRequestResponse from '../../../interfaces/ISaveUserRequestResponse';
import IValidateUserEmailResponse from '../interfaces/IValidateUserEmailResponse';

const TranslateUserTypeLabel = (label: string): string => {
    if (label === UserType[0]) {
        return 'Operador Transportadora';
    }

    return 'Admin. Transportadora';
};

const TranslateUserTypeEnum = (type: number = 0) => {
    return TranslateUserTypeLabel(UserType[type]);
};

const saveUserRequest = async (
    userData: IUserFormData,
    isRequestByThird: boolean = false,
): Promise<ISaveUserRequestResponse> => {
    const api = await getAuthAxiosInstance();

    const request: ISaveUserRequestRequest = {
        name: userData.name,
        email: userData.email,
        type: userData.type,
        carrierId: userData.userCarrier.carrierId,
        carrierName: userData.userCarrier.name,
        carrierSulaHubId: userData.userCarrier.sulaHubId,
        userAllowedSystems: userData.systems.map(system => ({
            sulaSystem: system.number,
            isAllowed: system.isChecked,
        })),
    };

    try {
        const { data } = await api.post<ISaveUserRequestResponse>(
            isRequestByThird ? 'v1/users-requests:third' : 'v1/users-requests',
            request,
        );

        return data;
    } catch {
        throw new Error(
            `Ocorreu um problema ao tentar adicionar uma nova requisição de usuário`,
        );
    }
};

const checkIfUserEmailIsValid = async (
    email: string,
): Promise<IValidateUserEmailResponse> => {
    const api = await getAuthAxiosInstance();

    const response = await api
        .get('v1/users:validate-email', { params: { email } })
        .catch((error: any) => {
            if (error?.response?.status !== 400) {
                throw new Error(
                    'Ocorreu um problema ao tentar validar o e-mail informado',
                );
            }
        });

    if (!response) {
        return {
            isInvalid: true,
            isDeactivated: false,
            isAmbevEmail: true,
        } as IValidateUserEmailResponse;
    }

    return {
        isInvalid: response.data.isInvalid,
        isDeactivated: response.data.isDeactivated,
        carrierName: response.data.carrierName,
    } as IValidateUserEmailResponse;
};

export default (() => {
    return {
        TranslateUserTypeLabel,
        TranslateUserTypeEnum,
        saveUserRequest,
        checkIfUserEmailIsValid,
    };
})();
